<template>
  <div class="toggle-wrapper">
    <label class="switch">
      <input :id="id" type="checkbox" v-model="value" :checked="value" :disabled="disabled || readOnly"/>
      <span :class="{ 'checkbox-disabled' : disabled || readOnly }" class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "input-toggle",
  props: {
    id: String,
    checked: Boolean,
    onChange: Function,
    disabled: Boolean,
    readOnly: Boolean
  },

  data: function() {
    return {
      value: this.checked
    }
  },

  watch: {
    checked(value) {
      this.value = value;
    },
    value(value) {
      this.onChange(value)
    }
  }
}
</script>